import request from '@/config/axios'

// 烂尾单原因分类 VO
export interface OrderStallReasonVO {
  id?: number // 编号
  name?: string // 原因名称
  remark?: string // 备注
  creator?: string
  createTime?: Date
}

// 烂尾单原因分类 API
export const OrderStallReasonApi = {
  // 查询烂尾单原因分类分页
  getOrderStallReasonPage: async (params: any) => {
    return await request.get({ url: `/crm/order-stall-reason/page`, params })
  },

  // 查询全部烂尾单原因分类（用于「烂尾单分析」表单下拉）
  getOrderStallReasonListAll: async () => {
    return await request.get({ url: `/crm/order-stall-reason/list-all` })
  },

  // 查询烂尾单原因分类详情
  getOrderStallReason: async (id: number) => {
    return await request.get({ url: `/crm/order-stall-reason/get?id=` + id })
  },

  // 新增烂尾单原因分类
  createOrderStallReason: async (data: OrderStallReasonVO) => {
    return await request.post({ url: `/crm/order-stall-reason/create`, data })
  },

  // 修改烂尾单原因分类
  updateOrderStallReason: async (data: OrderStallReasonVO) => {
    return await request.put({ url: `/crm/order-stall-reason/update`, data })
  },

  // 删除烂尾单原因分类
  deleteOrderStallReason: async (id: number) => {
    return await request.delete({ url: `/crm/order-stall-reason/delete?id=` + id })
  },

  // 导出烂尾单原因分类
  exportOrderStallReason: async (params: any) => {
    return await request.download({ url: `/crm/order-stall-reason/export`, params })
  }
}
